import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import Logo from "./Logo";
import { NAV } from "../constants/testIds";
import { useVoice } from "../voice/VoiceProvider";

// Bottom input bar — ONE text input + ONE mic, both 48px tall (Section 5/6/9)
export default function BottomBar() {
  const [text, setText] = useState("");
  const loc = useLocation();
  const { state, isProcessing, toggleVoice, sendTextImmediate } = useVoice();
  const listening = state === "listening";
  const speaking = state === "speaking";
  const processing = isProcessing || state === "processing";

  const placeholder = (() => {
    switch (loc.pathname) {
      case "/murshid":     return "Ask Murshid an Islamic question...";
      case "/calendar":    return "Add a meeting, view schedule...";
      case "/geolocation": return "Find a mosque, halal food nearby...";
      case "/hajj":        return "Plan your Umrah / Hajj...";
      case "/messaging":   return "Send a message...";
      default:             return "Ask about Islam, schedule, navigate...";
    }
  })();

  const handleSend = () => {
    const v = text.trim();
    if (!v || processing) return;
    setText("");
    sendTextImmediate(v);
  };

  return (
    <>
      {/* Spacer above bottom bar to push Emergent badge out of overlap zone */}
      <div style={{ position: "fixed", bottom: 80, left: 0, right: 0, height: 0, pointerEvents: "none", zIndex: 1 }} />
      <div
        style={{
          position: "fixed", bottom: 0, left: 0, right: 0,
          background: "var(--dnya-card)",
          borderTop: `1px solid var(--dnya-mosaic-1)`,
          height: 80,
          zIndex: 999,
          display: "flex", alignItems: "center",
          padding: "16px 14px 16px 14px",
          paddingRight: 200,  // clear Made-with-Emergent badge
          gap: 10,
        }}
      >
        <input
          data-testid={NAV.bottomInput}
          value={text}
          onChange={(e) => setText(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter") handleSend(); }}
          placeholder={placeholder}
          aria-label="Ask Dnya"
          disabled={processing}
          style={{
            flex: 1,
            minWidth: 200,
            height: 48,
            padding: "0 18px",
            borderRadius: 24,
            border: `1px solid var(--dnya-border)`,
            background: "var(--dnya-input-bg)",
            color: "var(--dnya-text)",
            outline: "none",
            fontSize: 14,
            boxSizing: "border-box",
          }}
        />
        <button
          data-testid={NAV.bottomSend}
          onClick={handleSend}
          aria-label="Send text"
          disabled={processing}
          style={{
            height: 48, padding: "0 18px", borderRadius: 24,
            background: processing ? "var(--dnya-mosaic-2)" : "var(--dnya-mosaic-1)",
            color: "#ffffff",
            border: 0,
            cursor: processing ? "not-allowed" : "pointer",
            fontWeight: 600, fontSize: 13,
            display: "flex", alignItems: "center", justifyContent: "center",
            boxSizing: "border-box",
          }}
        >
          Send
        </button>
        <button
          data-testid={NAV.bottomMic}
          onClick={toggleVoice}
          aria-label={listening ? "Stop listening" : "Activate voice"}
          className={listening ? "dnya-mic-listening" : ""}
          disabled={processing && !listening}
          style={{
            width: 48, height: 48,
            borderRadius: "50%",
            background: "linear-gradient(135deg, #1a5c1a, #4a9a4a)",
            border: `2px solid var(--dnya-high-1)`,
            cursor: processing && !listening ? "not-allowed" : "pointer",
            display: "flex", alignItems: "center", justifyContent: "center",
            padding: 0, boxSizing: "border-box",
            opacity: processing && !listening ? 0.55 : 1,
          }}
        >
          {speaking ? (
            <div style={{ display: "flex", gap: 3, alignItems: "center", height: 24 }}>
              <span className="dnya-speaking-bar" style={{ height: 18 }} />
              <span className="dnya-speaking-bar" style={{ height: 24 }} />
              <span className="dnya-speaking-bar" style={{ height: 14 }} />
            </div>
          ) : (
            <Logo size={32} />
          )}
        </button>
      </div>
    </>
  );
}
